import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const imgStyle = { width: 'fit-content', marginTop: 5 };
const margin = { marginTop: 5 };

const MessageAttachment = ({ file }) => {
  const getAttachment = () => {
    if (file.video) {
      return (
        <Link href={file.download_url} style={{ marginBottom: 10 }} passHref>
          This is a video file. Click to download.
        </Link>
      );
    }

    if (file.image) {
      return (
        <Link href={file.download_url} passHref>
          <div style={imgStyle}>
            <Image width={120} height={200} src={file.url} alt="" unoptimized />
          </div>
        </Link>
      );
    }

    return (
      <Link href={file.download_url} passHref>
        <div style={margin}>No Preview for this file. Click to download.</div>
      </Link>
    );
  };

  return getAttachment();
};

export default MessageAttachment;
